export function addZeroInSingleDigit(digit) {
    // Here, digit must be a string
    const numDigit = parseInt(digit);
    if (numDigit / 10 >= 1) {
        return digit;
    } else {
        return "0" + digit;
    }
}